// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__SHk7z","dragIcon":"SortableItem_dragIcon__2atLO","disabled":"SortableItem_disabled__3n9yj"};